import { CommonUtilities } from 'commonUtils';
import { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import LoadCastFile from '../UploadCast';

export default function CastUpsert(param: any) {

    let [savedStatus, setSavedStatus] = useState(true);
    let [ignoreChange, setIgnoreChange] = useState(true);
    let [importWizard, setImportWizard] = useState(false);
    let [filterSelection, SetFilterSelection] = useState<any>([]);

    const onCloseDrawer = () => {

        console.log(filterSelection)

        if (savedStatus == false) {
            ignoreChange = true;
            setIgnoreChange(ignoreChange)
            CommonUtilities.showToastDawer('Some data unsave', 'fail')
        } else {
            param.CastsUpsertChange();
        }

    }

    useEffect(() => {

        console.log(param?.CueSelected)

        filterSelection = param?.CueSelected ?? []
        SetFilterSelection(filterSelection)
        const handleEsc = (e: any) => {
            if (e.key === 'Escape') {
                onCloseDrawer();
            }
        };

        document.addEventListener('keydown', handleEsc);

        return () => {
            document.removeEventListener('keydown', handleEsc);
        };
    }, [onCloseDrawer]);

    const saveChange = () => {

        savedStatus = true;
        setSavedStatus(savedStatus)
        CommonUtilities.showToastDawer('Production Saved', 'Success')
    }

    const castListName = (e: any) => {

        if (e.length > 0) {

            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
            const day = String(today.getDate()).padStart(2, "0");
            const formattedDate = year + month + day
            SetFilterSelection({ ...filterSelection, CastListName: "Cast List -" + e + " - " + formattedDate, })
        } else {

            SetFilterSelection({ ...filterSelection, CastListName: "", })
        }
    }

    let [loadCast, SetloadCast] = useState(false);
    const LoadCastFileChange = (e: any) => {
        loadCast = false
        SetloadCast(loadCast)
    }
    return (

        <Drawer open={param.CastUpsertOpen}
            onClose={onCloseDrawer}
            direction='right'
            className='react-drawer  allowHscroll allowVscroll'
            size={800}>


            <div className="box noBorderRadius noBorder ws-4 pull-right pm full-height-vh">

                <div className='ws-12 pm'>

                    <div className='ws-10'>
                        <h1 className='text-bold'> Create New Cast</h1>
                        <span className=' ptl'>Add New Cast.</span>
                    </div>

                    <button onClick={() => onCloseDrawer()} className="btn-xxs  borderNone bgTransparent pull-right mtxl"  >
                        <i className="icon-close3 danger"></i>
                    </button>

                </div>

                <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>

                <div className='ws-11 paddingCenterBox pLarge'>

                    <div className='ws-12 pm'>
                        <label className='text-bold ws-12'> Select Production*</label>
                        <input className='ws-12' onChange={(e) => { SetFilterSelection({ ...filterSelection, productionName: e.target.value, }); setSavedStatus(false); castListName(e.target.value); }} value={filterSelection.productionName ?? ""} />
                    </div>

                    <div className='ws-12 pm'>
                        <label className='text-bold ws-12'> Cast List Name</label>
                        <input className='ws-12' disabled value={filterSelection?.displayName ?? ""}  />
                    </div>

                    <div className='ws-12 pm'>
                        <label className='text-bold ws-12'>Cast Type</label>
                        <input className='ws-12' onChange={(e) => { SetFilterSelection({ ...filterSelection, castType: e.target.value, }); setSavedStatus(false); castListName(e.target.value); }} value={filterSelection.castType ?? ""}/>

                    </div>

                    <div className='ws-12 pm'>
                        <label className='text-bold ws-12'>Status </label>
                        <input className='ws-12' onChange={(e) => { SetFilterSelection({ ...filterSelection, status: e.target.value, }); setSavedStatus(false); castListName(e.target.value); }} value={filterSelection.status ?? ""} />

                    </div>

                    <div className='ws-12 pm alignBottom'>
                        <button className='text-bold text-l mr icon-btn info noBorder noOutline ' onClick={() => SetloadCast(true)}>
                            <i className='icon-angle-left text-l mr mt mb'></i>
                            <span className='text-left mt m'>File import</span>
                        </button>

                        <label className="switch hide">
                            <input type="checkbox" name="creator" checked={importWizard} onChange={() => setImportWizard(!importWizard)} />
                            {importWizard && <span className="slider round text-left white pm pts" >Yes</span>}
                            {!importWizard && <span className="slider round text-right white pm pts sliderOff">No</span>}
                        </label>
                        <button type="button" className=" icon-btn close text-bold pull-right  height40 width100" onClick={() => onCloseDrawer()}>Close</button>
                    </div>


                    <div className='ws-12 pm box-footer hide' >
                        <button type="button" className=" icon-btn close text-bold pull-right  height40 width100" onClick={() => onCloseDrawer()}>Close</button>
                    </div>

                </div>

                {
                    (() => {

                        if (loadCast) {
                            return <LoadCastFile LoadCastFileChange={LoadCastFileChange} loadCast={loadCast} />
                        }
                    })()
                }
            </div>

        </Drawer>

    )

}